import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";

const links = [
  { label: "Studio", href: "#studio" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-white/70 border-b border-black/5"
      data-testid="main-nav"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a href="#" data-testid="nav-brand-link" className="font-syne font-bold text-lg tracking-tight">
          SIVIC<span className="text-primary">.</span>
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm font-medium">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/admin"
            data-testid="nav-login-link"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-300"
          >
            Login
          </Link>
          <a
            href="#contact"
            data-testid="nav-start-project-button"
            className="inline-flex items-center gap-2 bg-foreground text-white px-5 py-2.5 text-sm font-medium hover:bg-primary transition-colors duration-300 active:scale-[0.98]"
          >
            Start a project <ArrowUpRight size={15} />
          </a>
        </div>
        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden border-t border-black/5 bg-white/90 backdrop-blur-xl"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className="font-syne font-semibold text-xl"
                >
                  {l.label}
                </a>
              ))}
              <Link
                to="/admin"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-login-link"
                className="font-syne font-semibold text-xl"
              >
                Login
              </Link>
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-start-project-button"
                className="inline-flex items-center gap-2 bg-foreground text-white px-5 py-3 text-sm font-medium w-fit"
              >
                Start a project <ArrowUpRight size={15} />
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
